import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appTrimSpaces]',
    standalone: false
})
export class TrimSpacesDirective {
  private readonly ngControl = inject(NgControl);
  private readonly elRef = inject(ElementRef);

  @HostListener('blur', ['$event'])
  onBlur(event): void {
    this.ngControl.control.setValue(this.elRef.nativeElement.value.trim());
  }
}
